import { SELECT_INPUT_TYPE, VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";
import { LAST_YEARS, MONTHS } from "@utils/Constants";
import { getEmailYupValidation } from "@utils/Forms";
import { AccountingPackageMode } from "@utils/accountingPackage/reports";

/**
 * Config del formulario del paquete contable. El campo de mes solo se arma en el
 * modo mensual: el anual pide unicamente el año y el correo.
 */
const buildAccountingPackageFormConfig = (mode: AccountingPackageMode) => {
    const monthField = [
        {
            "type": SELECT_INPUT_TYPE,
            "name": "month",
            "label": "Mes",
            "isHorizontal": true,
            "labelSizing": {
                "sm": 3
            },
            "sizing": {
                "sm": 8
            },
            "options": MONTHS,
            "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
        },
    ];

    const yearField = [
        {
            "type": SELECT_INPUT_TYPE,
            "name": "year",
            "label": "Año",
            "isHorizontal": true,
            "labelSizing": {
                "sm": 3
            },
            "sizing": {
                "sm": 8
            },
            "options": LAST_YEARS,
            "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
        },
    ];

    const emailsField = [
        {
            "type": "email",
            "name": "emails",
            "label": "Correo Electronico",
            "isHorizontal": true,
            "labelSizing": {
                "sm": 3
            },
            "sizing": {
                "sm": 8
            },
            "validation": getEmailYupValidation()
        },
    ];

    return {
        submit: {
            label: "Generar y Enviar"
        },
        sections: [
            {
                hideBorderBottom: true,
                "fields": mode === "month"
                    ? [monthField, yearField, emailsField]
                    : [yearField, emailsField]
            }
        ],
    };
}

export default buildAccountingPackageFormConfig;
